import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LoginHeader from "../header/LoginHeader";
import LoginForm from "../user/LoginForm";
// import useLiff from "../../hooks/useLiff";

const Login = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [lang, setLang] = useState(i18n.language);
  // const { profile, loggedIn, handleLogin, handleLogout } = useLiff();
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    setLang(i18n.language);
  }, [i18n.language]);

  // ถ้าไม่มี history ก่อนหน้า ให้กลับไปหน้า Main
 /* useEffect(() => {
    console.log(window.history);
   // if (window.history.length <= 2) {
      // กรณีเข้า login โดยตรง เช่นจาก external link
      window.history.pushState({}, "", "/");
      navigate(-1); // ไปหน้า Main
    //}
  }, []);*/

  return (
    <div>
      <div className="w-full h-screen bg-secondary-background-gray">
        <LoginHeader />
        <LoginForm lang={lang} />
      </div>
    </div>
  );
};

export default Login;
